import '../scss/style.scss';
import { main as mainCookies } from "./modules/cookies.js";
import { initLineReveal } from "./modules/line-reveal.js";

document.addEventListener('DOMContentLoaded', () => {
	// Activate the pinned header once the opening block has been scrolled through.
	// The flag goes on .wp-site-blocks so CSS can restyle the header, the
	// breadcrumb and anything else from a single ancestor state.
	const siteRoot = document.querySelector( '.wp-site-blocks' );
	const stickyHeader = document.querySelector( 'header.wp-block-template-part' );
	if ( siteRoot && stickyHeader ) {
		// Same anchor the chrome rules use in scss/style.scss: the first block of
		// the page content. Templates without post content fall back to whatever
		// follows the bar.
		const opening =
			document.querySelector( '.wp-block-post-content > *' ) ||
			stickyHeader.nextElementSibling;

		// The section after the opening block reaching the top of the viewport is
		// the reliable signal: a sticky opening block (page-hero) stays pinned, so
		// it never stops intersecting and can't be observed for this.
		const trigger = opening?.nextElementSibling || opening;

		if ( trigger ) {
			let queued = false;
			const sync = () => {
				queued = false;
				const passed = trigger === opening
					? trigger.getBoundingClientRect().bottom <= 0
					: trigger.getBoundingClientRect().top <= 0;
				siteRoot.classList.toggle( 'is-sticky-active', passed );
			};
			const onScroll = () => {
				if ( queued ) return;
				queued = true;
				requestAnimationFrame( sync );
			};

			addEventListener( 'scroll', onScroll, { passive: true } );
			addEventListener( 'resize', onScroll, { passive: true } );
			sync(); // reloading mid-page must not start out unstyled
		}
	}
	mainCookies();
	initLineReveal();
	// Reveal animations. Blocks ship `animate`; swapping it for `animated` here
	// means the hidden state only ever exists when this script is around to undo
	// it. The bottom rootMargin keeps entrances from firing while an element
	// merely peeks at the fold — on mobile the toolbar makes the real viewport
	// differ from CSS 100vh, so the next section otherwise animated on load.
	const animationObserver = new IntersectionObserver( ( entries ) => {
		entries.forEach( ( entry ) => {
			if ( ! entry.isIntersecting ) return;
			// The observed node may be an untransformed wrapper — reveal the block inside.
			const block = entry.target.classList.contains( 'animated' )
				? entry.target
				: entry.target.querySelector( '.animated' );
			block?.classList.add( 'intersecting' );
			animationObserver.unobserve( entry.target );
		} );
	}, { threshold: 0, rootMargin: '0px 0px -15% 0px' } );
	document.querySelectorAll( '.animate' ).forEach( ( block ) => {
		block.classList.replace( 'animate', 'animated' );
		// Observe an untransformed ancestor when present — watching the block itself
		// breaks once its transform pushes it off-screen (e.g. translateY(100%)).
		animationObserver.observe( block.closest( '.animation-wrapper' ) || block );
	} );

	// Start the marquee ~1s after load: Safari composites the track from the
	// pre-font/pre-image layout and never refreshes it if it starts earlier.
	const startProblemsMarquee = () => {
		if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
			return;
		}
		document.querySelectorAll( '.wp-block-reqst-problems .problems-track' )
			.forEach( ( track ) => track.classList.add( 'is-animating' ) );
	};
	if ( document.readyState === 'complete' ) {
		setTimeout( startProblemsMarquee, 1000 );
	} else {
		window.addEventListener( 'load', () => setTimeout( startProblemsMarquee, 1000 ) );
	}
});
